var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.431 144.719C239.275 108.335 224.395 99.2271 197.28 80.1949C170.165 61.1627 152.418 32.1942 104.307 33.4177C56.1945 34.6288 -9.21951 144.324 54.0565 208.848C117.332 273.372 227.682 218.179 235.431 144.719Z",
    fill: "#E9F2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5805 157.683C51.471 157.683 54.6249 154.529 54.6249 150.639C54.6249 146.748 51.471 143.594 47.5805 143.594C43.69 143.594 40.5361 146.748 40.5361 150.639C40.5361 154.529 43.69 157.683 47.5805 157.683Z",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.579 236.259H185.354",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.473 231.377V241.153",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.849 132.88H221.837",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.843 126.886V138.874",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.472 102.786V202.063H76.6851V98.0035V84.9652V70.4439V57.764C76.6851 56.4663 77.1423 55.2181 77.9456 54.2912L86.2506 47.2097L96.9284 55.7125L107.68 47.1479L118.395 55.7125L129.085 47.1727L139.726 55.7125L150.231 47.2839L160.711 55.7125L171.092 47.358L179.212 54.2912C180.015 55.2181 180.46 56.4663 180.46 57.7516V104.43",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6851 70.4439V57.764C76.6851 56.4663 77.1423 55.2181 77.9456 54.2912L84.7058 48.5321C85.608 47.7659 86.918 47.7411 87.8449 48.4827L95.396 54.4889C96.2981 55.2057 97.5711 55.2057 98.4733 54.4889L106.148 48.3838C107.05 47.667 108.323 47.667 109.225 48.3838L116.863 54.4766C117.765 55.1934 119.05 55.1934 119.952 54.4766L127.553 48.4085C128.455 47.6917 129.74 47.6917 130.643 48.4085L138.181 54.4642C139.084 55.1934 140.369 55.1934 141.271 54.4642L148.686 48.5197C149.588 47.7906 150.874 47.7906 151.788 48.5197L159.179 54.4642C160.081 55.1934 161.378 55.1934 162.281 54.4642L169.523 48.6433C170.45 47.9018 171.772 47.9142 172.674 48.6928L179.237 54.2912C180.04 55.2181 180.485 56.4663 180.485 57.7516V104.43",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.472 102.786V192.176C180.472 197.639 176.048 202.063 170.586 202.063H86.5719C81.1094 202.063 76.6851 197.639 76.6851 192.176V98.0037",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7275 202.483C36.6184 202.483 229.215 202.483 229.215 202.483",
    stroke: "#6895F5",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.159 110.708C119.917 110.708 122.152 108.473 122.152 105.716C122.152 102.958 119.917 100.723 117.159 100.723C114.402 100.723 112.166 102.958 112.166 105.716C112.166 108.473 114.402 110.708 117.159 110.708Z",
    fill: "#6895F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.033 110.708C140.79 110.708 143.026 108.473 143.026 105.716C143.026 102.958 140.79 100.723 138.033 100.723C135.275 100.723 133.04 102.958 133.04 105.716C133.04 108.473 135.275 110.708 138.033 110.708Z",
    fill: "#6895F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.078 125.366C122.078 125.366 127.577 117.358 135.549 124.167",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.04 86.5476C133.04 86.5476 134.721 90.0204 139.565 90.7495",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.228 86.5476C123.228 86.5476 121.547 90.0204 116.702 90.7495",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4221 93.4802C56.9114 121.349 75.7706 125.365 75.7706 125.365",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9122 87.2393C45.9122 87.2393 45.7886 91.7254 49.1749 93.3444",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9577 87.437C53.9577 87.437 52.1781 93.4186 49.4221 93.4804",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.692 86.3989C213.692 86.3989 213.445 90.8851 209.935 92.2198",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M205.659 85.9294C205.659 85.9294 206.932 92.0346 209.676 92.3312",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1704 147.907H166.631",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1704 165.741H166.631",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.921 183.574H166.631",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1704 183.574H131.965",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.676 92.3186C199.9 119.47 180.781 121.917 180.781 121.917",
    stroke: "#6895F5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M204.127 165.741C204.127 152.666 193.536 142.074 180.46 142.074C167.385 142.074 156.793 152.666 156.793 165.741C156.793 178.817 167.385 189.408 180.46 189.408C185.886 189.408 190.891 187.579 194.883 184.501C199.196 181.177 202.335 176.407 203.558 170.907C203.941 169.251 204.127 167.521 204.127 165.741Z",
    fill: "white",
    stroke: "#FD6F7B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.315 175.245C183.327 176.814 182.067 178.087 180.51 178.1C178.915 178.1 177.642 176.851 177.642 175.282C177.642 173.7 178.891 172.415 180.448 172.402C182.03 172.402 183.303 173.663 183.315 175.245Z",
    fill: "#FD6F7B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M184.452 156.868C184.402 158.511 184.205 160.155 183.958 161.774C183.661 163.652 183.303 165.531 182.796 167.36C182.45 168.596 182.091 169.832 181.424 170.956C181.3 171.166 181.127 171.377 180.954 171.55C180.621 171.871 180.275 171.871 179.941 171.562C179.508 171.167 179.261 170.647 179.026 170.116C178.347 168.559 177.902 166.915 177.581 165.247C177.222 163.418 176.913 161.564 176.654 159.71C176.468 158.449 176.369 157.164 176.468 155.879C176.53 155.088 176.678 154.309 177.037 153.593C177.618 152.431 178.569 151.838 179.842 151.739C180.547 151.689 181.251 151.677 181.943 151.912C183.216 152.332 183.908 153.296 184.205 154.544C184.378 155.298 184.44 156.089 184.538 156.868C184.501 156.855 184.477 156.868 184.452 156.868Z",
    fill: "#FD6F7B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.6b52bc2aef08a33b691c10e4d978f748.svg";
export { ForwardRef as ReactComponent };